/* ============
 * Mutation types for the account module
 * ============
 *
 * The mutation types that are available
 * on the auth module.
 */

export const MYCUSTOMERS = 'MYCUSTOMERS';
export const MYPROJECTS = 'MYPROJECTS';
export const MYBROKERS = 'MYBROKERS';
export const BROKERLISTWITHDRM = 'BROKERLISTWITHDRM';

export default {
  MYCUSTOMERS,
  MYPROJECTS,
  MYBROKERS,
  BROKERLISTWITHDRM,
};



// WEBPACK FOOTER //
// ./src/store/modules/saleshead/mutation-types.js